<template>
  <div>
    <o-field-group
      v-slot="{ status }"
      rules="required"
      class="w-full"
      :label="item.label"
      :info="item.description || ''"
    >
      <toggle-field
        v-if="item.type === 'boolean'"
        v-model="_value"
        :value="1"
        :unchecked-value="0"
        :label="item.label"
        :status="status"
      />

      <text-field
        v-if="item.type === 'text'"
        v-model="_value"
        :label="item.label"
        :status="status"
      />

      <select-field
        v-if="item.type === 'select'"
        v-model="_value"
        :label="item.label"
        :status="status"
        :options="item.options"
      />
    </o-field-group>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

import {
  ToggleField,
  SelectField,
  TextField,
} from '@/components/fields'

interface Props {
  modelValue: string | boolean | number
  item: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

onMounted(() => {
  if (_value.value === undefined || _value.value === null) {
    _value.value = props.item.default
  }
})
</script>
